/**
 * utilityFunctions.js
 * Created by calhosh on 8/27/2020.
 */

import React from 'react';
import {currentResource, getFilteredQueryParameter, isNullOrUndefined, labels, numberFormattedText} from './utils';
import queryString from 'query-string';
import {
	canvasWebRoutes,
	canvasUrlParams,
	documentTypes,
	DocumentStatus,
	ContentContract,
	PaperProfileIDs,
	serviceURL,
	entities,
	dateFormats,
	defaultDateFormat,
	OpenInCanvasDocumentTypeIDs,
	EngagementCommentStatus,
	documentNameMaxLength,
	OfflineTaskListFilters,
	taskApiRoutes,
	relateDocumentsTo,
	smartScreenRoutes,
	EngagementStatus,
	aresTaskViewRoutes,
	AccountType,
	fileExtensionMapping,
	actionType,
	actionTags,
	validationFilter,
	SmartAutomationEvidenceIDs,
	documentCategoryNames,
	GuidedWorkflowV2DocumentTypes,
	CanvasFormsIds,
	documentSources,
	formBodyType,
	CanvasFormsWithoutNavigationPanel,
	EvidenceDocumentTypeFromTemporaryDocumentTypeMap,
	ClassicSummaryScreenDocumentTypes,
	StatementType,
	AssertionIds,
	riskTypes,
	riskTypeList
} from './uiconstants';
import moment from 'moment';
import env from '../util/env';
import _ from 'lodash';
import {getValidationCountForIds} from '../components/Common/CanvasForm/Common/ValidationUtility';
import {decodeURIComponentSafe} from '../components/Common/EngagementComment/Utility/commentsUtilityFunctions';
import {applyRound} from '@ey/utils';
import DOMPurify from 'dompurify';
import {matchRoutes} from 'react-router';
import parse from 'html-react-parser';
import MotifButton from '@ey/motif-react-wrapper/Button';

let storedPayload = {};
let dragAndDropUploadObject = [];

class Utility extends Object {
	static getCanvasBaseUrl = (engagement, displayLanguage) => {
		let curl = env.getURL('eng_web') + '/pages/index/index.html?';
		curl = `${curl}countryid=${engagement.countryId}&`;
		curl = `${curl}engagementid=${engagement.engagementId}&`;
		curl = engagement.clientid ? `${curl}clientid=${engagement.clientid}` : curl;
		curl = engagement.clientname ? `${curl}clientname=${encodeURIComponent(engagement.clientname)}` : curl;
		curl = `${curl}workspacedesc=${encodeURIComponent(engagement.workspaceDescription)}&`;
		curl = `${curl}workspaceid=${engagement.workspaceId}&`;
		curl = `${curl}userPrefLang=${displayLanguage ? displayLanguage : ''}&`;
		curl = `${curl}engagementversion=${engagement.engagementVersion}`;
		return curl;
	};

	static getAutomationHubLink = (baseCanvasUrl, engagement, engagements, isAutomationHubEnabled) => {
		if (isAutomationHubEnabled === false || !engagements || engagements.length === 0) {
			return baseCanvasUrl + '#automationhub';
		} else {
			if (engagements && engagements.length > 0) {
				const thisEngagement = engagements.find((emd) => emd.engagementid === engagement.engagementId);
				return `${env.getURL('Smart_Automation_Url')}?engagementid=${engagement.engagementId}&countryId=${
					engagement.countryId
				}&dataCenterId=${thisEngagement?.datacenterid}`;
			}
		}
	};

	static getAutomationHubUrlFromFeature = (path = '', features) => {
		if (features?.eySmartAutomationBase) {
			return `${_.trimEnd(features?.eySmartAutomationBase, '/')}${path}`;
		} else {
			env.getSmartAutomationUrl(path);
		}
	};

	static isISOFormat(dateString) {
		return dateString.length === 24 && dateString.endsWith('Z');
	}

	static isValidDate(dateString) {
		var date = new Date(dateString);
		return !isNaN(date);
	}

	static getJsonPatchDocumentElement(operation, property, propertyValue) {
		return {op: operation, path: property, value: propertyValue};
	}

	static getErrorMessageFromResponse(responseMessage) {
		let error;
		try {
			if (responseMessage && responseMessage.indexOf(' - ') > 0) {
				error = responseMessage.substr(0, responseMessage.indexOf(' -'));
			}
		} catch (err) {
			/* empty */
		}
		if (error && error.length > 0 && !Array.isArray(error)) {
			if (!error.ErrorCode) {
				const errorValue = Number(error);
				if (!isNaN(errorValue)) {
					return currentResource.Errors[errorValue]
						? error + ': ' + currentResource.Errors[errorValue]
						: responseMessage;
				}
			}
		}
		return responseMessage;
	}

	static getEngagementIdFromUrl(history) {
		let queryStringParams = queryString.parse(history.location.search.toLowerCase());
		let engId = queryStringParams.engagementid;

		// If the engagementId is sent multiple times in the url, keep the first one
		let engagementId = engId;
		if (engId && (Array.isArray(engId) || engId.indexOf(',') >= 0)) {
			engagementId = Array.isArray(engId) ? engId[0] : engId.split(',')[0];
			if (engagementId.indexOf(',') >= 0) {
				engagementId = engagementId.split(',')[0];
			}
		}

		return engagementId;
	}

	static getDocumentIdFromUrl(history) {
		let queryStringParams = queryString.parse(history.location.search.toLowerCase());
		let documentId = queryStringParams.documentid;
		if (Array.isArray(documentId)) {
			return documentId[0]?.toLowerCase();
		} else if (this.validateGUID(documentId)) {
			return documentId?.toLowerCase();
		} else {
			let locationSplit = history?.location?.href?.split('/');
			if (locationSplit.length > 4 && this.validateGUID(locationSplit[4].split('?')[0])) {
				documentId = locationSplit[4].split('?')[0];
			} else if (locationSplit.length > 5 && locationSplit[5] && this.validateGUID(locationSplit[5].split('?')[0])) {
				documentId = locationSplit[5].split('?')[0];
			} else {
				documentId = undefined;
			}
			return documentId?.toLowerCase();
		}
	}

	/**
	 * validates guid id.
	 * @param {Guid} guid - guid id.
	 * @returns {bool} validates guid.
	 * */
	static validateGUID(guid) {
		let isGUIDValid = false;
		const pattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
		if (pattern.test(guid)) {
			isGUIDValid = true;
		}

		return isGUIDValid;
	}

	static isEmptyGuid(value) {
		return _.isEmpty(value) || value === '00000000-0000-0000-0000-000000000000';
	}

	static parseRichText(text) {
		const markedText = Utility.createMarkup(text);
		return parse(markedText.__html);
	}

	/**
	 * sort an array by given keys.
	 * @param {Array} toSort - the array to sort.
	 * @returns {any} the sortedArray
	 * */
	static sortByMultipleKey(toSort) {
		let key = '';

		// check if toSort is array
		if (Array.isArray(toSort)) {
			if (toSort.length === 0) return 0;
			key = toSort[0];
		} else {
			key = toSort;
		}

		return function(a, b) {
			let valueA = a[key];
			let valueB = b[key];

			// Both values are strings. Compare them in a case-insensitive manner.
			if (typeof valueA === 'string' && typeof valueB === 'string') {
				valueA = valueA.toLowerCase();
				valueB = valueB.toLowerCase();
			}

			// nulls sort after anything else
			if (valueA === null) {
				return 1;
			} else if (valueB === null) {
				return -1;
			}
			// otherwise, if we're ascending, lowest sorts first
			else if (valueA < valueB) {
				return -1;
			}
			// if descending, highest sorts first
			else if (valueA > valueB) {
				return 1;
			}
			// equal items sort equally
			else {
				if (toSort.slice(1).length > 0) {
					return Utility.sortByMultipleKey(toSort.slice(1))(a, b);
				} else return 0;
			}
		};
	}

	static sortAlphaNumeric(arr = [], sortKey) {
		const compareAlphaNumeric = (a, b) => {
			let valueA = a[sortKey];
			let valueB = b[sortKey];

			// Both values are strings. Compare them in a case-insensitive manner.
			if (typeof valueA === 'string' && typeof valueB === 'string') {
				valueA = valueA.toLowerCase();
				valueB = valueB.toLowerCase();
			}

			if (valueA > valueB) return 1;
			if (valueA < valueB) return -1;
			return 0;
		};
		const compareNumeric = (a, b) => {
			if (a > b) return 1;
			if (a < b) return -1;
			return 0;
		};
		arr.sort(sortKey ? compareAlphaNumeric : compareNumeric);
	}

	/**
	 * Determines whether the components are being rendered in server-side mode.
	 * @returns {string} true if the components are being rendered as server-side; otherwise false.
	 * */
	static canUseDOM() {
		return typeof window !== 'undefined' && (typeof process === 'undefined' || process.browser);
	}

	/**
	 * Creates a rich text element to show rich text. Eg. (Bold, Italic, Underline...)
	 * rastwe: TODO: need some justification for having this here. Kendo editor?
	 * @param {string} text - the text to display
	 * @param {string} className - the className to display
	 * @param {function} onCLick - on click function
	 * @returns {Object} a rich text element to display
	 * */
	static createRichTextElement(text, className, onCLick) {
		if (this.canUseDOM() !== true && text) {
			return (
				<span
					onClick={(e) => {
						onCLick && onCLick(e);
					}}
					className={`createRichTextElementSpanWrapper ${className ? className : ''}`}
					dangerouslySetInnerHTML={Utility.createMarkup(text)}
				/>
			);
		} else if (text) {
			/*having this breaks kendo. We dont want to sanitize what the users enter into kendo.
			E.g if I enter this:
			test <script>alert('hi');</script> test
			<span class="info-test">engagement</span>
			<b>bold text</b>
			<a>anchor tag</a>
			<u>underlined</u>
			<i>italic</>
			<strong><span style="text-decoration: underline;"><em>Text description</em></span></strong>
			I want to see this as I wrote it NOT test test and actual bold text or anchor links.
			*/

			//const sanitizer = dompurify.sanitize;
			//text = sanitizer(_.unescape(text));
			return (
				<span
					onClick={(e) => {
						onCLick && onCLick(e);
					}}
					className={`createRichTextElementSpanWrapper ${className ? className : ''}`}
					dangerouslySetInnerHTML={Utility.createMarkup(text)}
				/>
			);
		}
	}

	/**
	 * Given a text with optional placeholders, returns a span element with every placeholder replaced with an anchor tag (<a>) with an onClick handler or not, based on isPrintView
	 * Example:
	 * text = 'some text blablablba {someKey1} more text ble ble ble {someKey2}' (where {someKey1} and {someKey2} are declared keys in the resource files)
	 * onPlaceholderClickConfig = {
	 * 	someKey1: onClickFunction1,
	 * 	someKey2: onClickFunction2,
	 * }
	 * @param {string} text Can be a plain string, or a string with placeholders that reference another key in the resource file, which can be used to render links with an assigned callback that displays a localized text.
	 * @param {object} onPlaceholderClickConfig Object with one property named after each placeholder key referenced in the text.
	 * @param {object} isPrintView "true" if no click needed and no underlined on hover. Otherwise "false"
	 * @returns {string} placeholder text.
	 */
	static createClickableTextCommon(text, onPlaceholderClickConfig, isPrintView) {
		let newPlaceholder;
		let regex = /(\{[A-Za-z]+\})/;
		if (text && onPlaceholderClickConfig) {
			const parsedText = text.split(regex);

			newPlaceholder = parsedText.map((segmentText) => {
				const isPlaceholder = segmentText.startsWith('{');
				let callbackKeyName;
				let linkCallback;
				let richText;

				if (isPlaceholder) {
					// Link with a callback declared in onPlaceholderClickConfig:
					callbackKeyName = segmentText.replace('{', '').replace('}', '');
					linkCallback = onPlaceholderClickConfig[callbackKeyName];
				} else {
					// Plain text. Wrapping it in a span to apply html tags
					richText = Utility.createRichTextElement(segmentText);
				}

				let cursorPointer;
				if (isPrintView) {
					cursorPointer = {
						cursor: 'unset',
						'text-decoration': 'none'
					};
				} else {
					cursorPointer = {
						cursor: 'pointer'
					};
				}
				return (
					<>
						{isPlaceholder ? (
							<MotifButton className="createClickableTextLink" variant={'text-alt'} onClick={linkCallback}>
								{labels[callbackKeyName]}
							</MotifButton>
						) : (
							<>{richText}</>
						)}
					</>
				);
			});
		} else {
			let matches;
			let replaceText;

			do {
				//This replaces {keyName} with the resource file's keyName value.
				matches = regex.exec(text);

				matches &&
					matches.map((match) => {
						replaceText = `<span style='font-weight:bold;'>${labels[match.substring(1, match.length - 1)]}</span>`;
						text = text.replace(match, replaceText);
					});
			} while (matches && matches.length > 0);

			newPlaceholder = Utility.createRichTextElement(text);
		}

		return newPlaceholder;
	}

	/**
	 * Given a text with optional placeholders, returns a span element with every placeholder replaced with an anchor tag (<a>) with an onClick handler if specified in onPlaceholderClickConfig.
	 * Example:
	 * text = 'some text blablablba {someKey1} more text ble ble ble {someKey2}' (where {someKey1} and {someKey2} are declared keys in the resource files)
	 * onPlaceholderClickConfig = {
	 * 	someKey1: onClickFunction1,
	 * 	someKey2: onClickFunction2,
	 * }
	 * @param {string} text Can be a plain string, or a string with placeholders that reference another key in the resource file, which can be used to render links with an assigned callback that displays a localized text.
	 * @param {object} onPlaceholderClickConfig Object with one property named after each placeholder key referenced in the text.
	 * @returns {object} span with placeholder text.
	 */
	static createClickableText(text, onPlaceholderClickConfig) {
		return Utility.createClickableTextCommon(text, onPlaceholderClickConfig, false);
	}

	/**
	 * Given a text with optional placeholders, returns a span element with every placeholder replaced with an anchor tag (<a>) but not underlined when hover.
	 * Example:
	 * text = 'some text blablablba {someKey1} more text ble ble ble {someKey2}' (where {someKey1} and {someKey2} are declared keys in the resource files)
	 * @param {string} text Can be a plain string, or a string with placeholders that reference another key in the resource file, which can be used to render links with an assigned callback that displays a localized text.
	 * @param {object} onPlaceholderClickConfig Object with one property named after each placeholder key referenced in the text.
	 * @returns {object} span with placeholder text.
	 */
	static createClickableTextForPrintView(text, onPlaceholderClickConfig) {
		return Utility.createClickableTextCommon(text, onPlaceholderClickConfig, true);
	}

	/**
	 * Private function to return html required for setting dangerous inner html
	 * @param {string} text - the text to display
	 * @returns {Object} an object with html set to the text passed in
	 * */
	static createMarkup(text) {
		if (typeof text === 'string') {
			const getRidOfImgTags = /&lt;img/g;
			text = text?.replace(getRidOfImgTags, '');
			const sanitizedText = Utility.getSanitizedText(text, {encode: false});
			return {__html: sanitizedText};
		}
	}

	/**
	 * Get a sanitized text after parsing input for XSS.
	 * @param {string} text - the input text
	 * @param {boolean} encode - flag to encode the text, usually for sending over the wire
	 * @returns {string} sanitized text
	 * */
	static getSanitizedText(text, {encode = false}) {
		const sanitizer = DOMPurify.sanitize;
		//let sanitizedText = unescape(sanitizer(text));
		let sanitizedText = sanitizer(text);
		if (encode) {
			sanitizedText = encodeURIComponent(sanitizedText);
		}
		return sanitizedText;
	}

	static getInnerTextFromRichText(html, removeInsertedDeletedData = false) {
		try {
			let element = document.createElement('div');
			element.innerHTML = html;

			if (removeInsertedDeletedData) {
				$(element)
					.find('.diffins')
					.remove();
			}
			// fix special chart from Kendo: &#65279

			if (element && element?.innerText && element?.innerText !== null) {
				return element.innerText.replace(/\uFEFF/g, '').trim();
			}
		} catch (err) {
			return '';
		}
	}

	/**
	 * Get a track changes version respone html text after parsing input text of XSS, Rich text etc.
	 * @param {string} text - the input text
	 * @param {boolean} removeInsertedDeletedData - flag to remove diff inserts and update the delete tags to text nodes
	 * @returns {string} html text
	 * */
	static getTrackChangesVersionText(html) {
		try {
			if (Utility.isRichTextContent(html)) {
				let element = document.createElement('div');
				element.innerHTML = html;
				return Utility.createRichTextElement(element.innerHTML.trim(), 'showMoreLessTextResponse', null);
			}
			return Utility.getHtmlTextElement(html.trim());
		} catch (err) {
			return '';
		}
	}

	/**
	 * Check the text content is Rich text or not.
	 * @param {string} text - the input text
	 * @returns {boolean} html text
	 * */
	static isRichTextContent(content) {
		// Regular expression to search for <p> tags
		const paragraphRegex = /<p[^>]*>[\s\S]*?<\/p>/gi;

		// Check if the content contains <p> tags
		return paragraphRegex.test(content);
	}

	static getDocumentChangeReasonApiUrl(engagementId, documentId) {
		return `${env.getBaseURL(serviceURL, engagementId)}documents/${documentId}/changereasons/`;
	}

	static parseQueryString(queryStringParameters) {
		const parsed = queryString.parse(queryStringParameters);
		let queryParams = {};

		for (let [propName, propValue] of Object.entries(parsed)) {
			queryParams[propName.toLocaleLowerCase()] = propValue;
		}

		if (queryParams.engagementid) {
			queryParams.engagementid = this.getEngagementIdFromUrl(window);
		}

		return queryParams;
	}

	/**
	 * forms canvas inCountry base url.
	 * @param {string} currentRoute - The current route.
	 * @param {string} document - Doc.
	 * @param {string} engagementInformation - Engagement.
	 * @param {string} inCountryServerBaseUrl - In country server base url.
	 * @param {string} herculesBaseUrl - Hercules base url.
	 * @param {string} customProps - Custom props.
	 * @returns {string} url.
	 * */
	static getCanvasWebUrlForDocument = (
		currentRoute,
		document,
		engagementInformation,
		inCountryServerBaseUrl,
		herculesBaseUrl,
		customProps
	) => {
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		let inCountryFullUrl = inCountryServerBaseUrl + '/pages/index/index.html' + '?';
		let queryString =
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(
				engagementInformation.engagementDescription !== undefined
					? engagementInformation.engagementDescription.substring(0, 50)
					: ''
			) +
			'&' +
			canvasUrlParams.workspacedesc +
			'=' +
			encodeURIComponent(
				engagementInformation.workspaceDescription !== undefined
					? engagementInformation.workspaceDescription.substring(0, 50)
					: ''
			) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion +
			'&' +
			canvasUrlParams.returnUrl +
			'=' +
			currentRoute;
		let documentTypeId = document.docTypeId ? document.docTypeId : document.documentTypeId;
		switch (documentTypeId) {
			case documentTypes.PROFILE: {
				// return (
				// 	env.getURL('eng_web') +
				// 	'/pages/engagementprofilepage/engagementprofile.html?' +
				// 	queryString
				// );
				return inCountryFullUrl + queryString + '#engagementprofile/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.ACCOUNTSSUMMARY: {
				return inCountryFullUrl + queryString + '#accountsummary';
			}
			case documentTypes.SCOTSSUMMARY: {
				return inCountryFullUrl + queryString + '#scotsummary';
			}
			case documentTypes.ITSOSUMMARY: {
				return inCountryFullUrl + queryString + '#itsummary';
			}
			case documentTypes.CRASUMMARY: {
				return inCountryFullUrl + queryString + '#crasummary';
			}
			case documentTypes.AUDITPLAN: {
				return inCountryFullUrl + queryString + '#plan';
			}
			case documentTypes.GROUPAUDITSTRUCTURESUMMARY: {
				return inCountryFullUrl + queryString + '#groupauditstructuresummary';
			}
			case documentTypes.GROUPAUDITINSTRUCTIONSUMMARY: {
				return inCountryFullUrl + queryString + '#groupauditinstructionsummary';
			}
			case documentTypes.GROUPCOMPONENTSUMMARYDOCUMENT: {
				return inCountryFullUrl + queryString + '#gacomponentsummary/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.WORKPLANSUMMARY: {
				return inCountryFullUrl + queryString + '#plan';
			}
			case documentTypes.ITEVALUATIONSMARTFORM: {
				return inCountryFullUrl + queryString + '#itevaluation/' + document.id;
			}
			case documentTypes.ITEVALUATIONTEMPORARYSMARTFORM: {
				return inCountryFullUrl + queryString + '#itevaluation/' + document.id;
			}
			case documentTypes.CANVASFORMEVIDENCE:
			case documentTypes.PROFILEV2:
			case documentTypes.ACCOUNT_CONCLUSION:
			case documentTypes.CANVASFORMTEMPORARY: {
				return (
					new URL(window.location.origin) + `canvasform?engagementid=${engagementId}&documentid=${document.id}` //&referrer=${window.location.href}`
				);
			}
			case documentTypes.INDEPENDENCEFORMTEMPLATE: {
				return (
					herculesBaseUrl + smartScreenRoutes.independence + `?engagementid=${engagementId}&documentid=${document.id}`
				);
			}
			case documentTypes.ACCOUNTCONCLUSIONCLASSIC: {
				return inCountryFullUrl + queryString + '#accountconclusion/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.ARCHIVE: {
				return inCountryFullUrl + queryString + '#archive/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.DETERMINEPMTESAD: {
				return inCountryFullUrl + queryString + '#materiality/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.SEM: {
				return herculesBaseUrl + '/smartscreens/sem?engagementid=' + engagementId + '&documentid=' + document.id;
			}
			case documentTypes.FOUR_FORTY_GL: {
				return herculesBaseUrl + '/smartscreens/440gl?engagementid=' + engagementId + '&documentid=' + document.id;
			}
			case documentTypes.GUIDEDWORKFLOW:
			case documentTypes.GUIDEDWORKFLOWTEMPORARY:
			case documentTypes.LIMITEDRISKDOCUMENTATION:
			case documentTypes.GUIDEDWORKFLOWV2:
			case documentTypes.ESTIMATESDOCUMENT:
			case documentTypes.ANALYTICSDOCUMENT:
			case documentTypes.MULTIENTITYINDIVIDUALPROFILE:
			case documentTypes.MULTIENTITYSUBPROFILE:
			case documentTypes.ACCOUNTLEVELRISKASSESSMENT:
			case documentTypes.PIC_CHECKLIST:
			case documentTypes.EQR_CHECKLIST:
			case documentTypes.GROUPSTRUCTUREGUIDEDWORKFLOW:
			case documentTypes.GROUPINSTRUCTIONGUIDEDWORKFLOW:
			case documentTypes.GUIDEDWORKFLOWV2_TEMPORARY:
			case documentTypes.CANVASFORMSNAPSHOT:
			case documentTypes.ALRA_INDIVIDUAL:
			case documentTypes.CLIENT_SHARED_HELIX_ANALYTIC:
			case documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT:
			case documentTypes.IT_FLOW_ISA315:
			case documentTypes.GROUP_INVOLVEMENT_SUMMARY: {
				let url = new URL(window.location.origin) + `fit?engagementid=${engagementId}&documentid=${document.id}`;
				if (customProps?.stentityid) {
					url += `&stentityid=${customProps.stentityid}`;
				}

				return url;
			}
			case documentTypes.SMARTAUTOMATIONEVIDENCE:
			case documentTypes.SMARTAUTOMATIONEVIDENCETEMPORARY: {
				return this.getAutomationHubUrlFromFeature(
					`?engagementid=${engagementId}&countryId=${engagementInformation.countryId}&dataCenterId=${customProps.datacenterid}&requestid=${document.smartEvidenceSourceId}`,
					customProps.features
				);
			}
			default:
				return '';
		}
	};

	static getEngagementCommentStatusName = (statusId) => {
		switch (statusId) {
			case EngagementCommentStatus.open:
				return 'open';
			case EngagementCommentStatus.cleared:
				return 'cleared';
			case EngagementCommentStatus.closed:
				return 'closed';
		}
	};

	static getCurrentUrl = (location) => {
		let result = location.pathname;

		if (result.startsWith('/')) {
			result = result.substring(1);
		}
		result = result.replaceAll('/', '_');

		return `${result}${encodeURIComponent(location.search)}`;
	};

	static openDocumentForEditing = (payload) => {
		console.log('Opening Document 📃✔✔✔✔✔');

		let _connectionID;

		if (window.jQuery.connection && window.jQuery.connection[env.getDocHelperConfig().hubName]) {
			_connectionID = window.jQuery.connection[env.getDocHelperConfig().hubName].connection.id;
		}

		let payloadData = {
			...payload.payloadData,
			connectionId: _connectionID || undefined
		};

		let url = {
			openDocument: true,
			fileId: payloadData.documentId,
			docTypeId: payloadData.docTypeId,
			engagementId: payloadData.engagementId,
			docUrl: env.getDocServiceUrl(),
			resourceUri: env.getURL('Engg_AuthAudience_URL'),
			readonly: payload.actionTag === 'openr',
			includeDeleted: payload.includeDeleted
		};

		if (payloadData.fileVersion) {
			url.fileVersion = payloadData.fileVersion;
		}

		let docHelperUri = env.getDocHelperConfig().docHelperApiUri + 'Document' + '?' + Utility.createQueryString(url);

		try {
			payload.actions
				.downloadDocumentWithDocumentHelper(docHelperUri, payloadData, {
					connectionid: payloadData.connectionId
				})
				.then((response) => {
					try {
						if (!(response && response.data)) {
							return;
						}
						let filename = '';
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;

						let disposition = response.headers['content-disposition'];
						if (disposition && disposition.toLowerCase().indexOf('attachment') !== -1) {
							var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
							var matches = filenameRegex.exec(disposition);
							if (matches !== null && matches[1]) {
								try {
									filename = decodeURIComponentSafe(matches[1].replace(/['"]/g, ''));
								} catch (err) {
									filename = matches[1].replace(/['"]/g, '');
								}
							}
						}

						// need to figure out file name on download
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
					} catch (err) {
						console.log('Unable to download document from DocService.');
					}
				});
		} catch (e) {
			console.log('No Connection to DocHelper Available');
			payload.actions.raiseDochelperError(['0010', 'Connection Failed', payload.labels.documentHelperConnectionIssue]);
		}
	};

	static openDocument = (
		parentName,
		document,
		downloadDocumentWithDocumentHelper,
		raiseDochelperError = undefined,
		actionTag = actionTags.openReadOnly
	) => {
		const payload = {
			payloadData: {
				documentHubStatus: 'DOWNLOADSTART',
				parentName: parentName,
				documentId: document.id,
				documentName: `${document.documentName}.${document.fileExt}`,
				docTypeId: document.documentTypeId,
				transactionId: document.id,
				documentType: document.documentTypeId,
				ProgressPercent: 0,
				totalPercentage: 100,
				inProgress: true,
				engagementId: document.engagementId,
				dockey: `_${document.id}`
			},
			actions: {
				downloadDocumentWithDocumentHelper,
				raiseDochelperError
			},
			actionTag,
			labels: {
				documentHelperConnectionIssue: currentResource.labels.documentHelperConnectionIssue
			}
		};

		this.openDocumentForEditing(payload);
	};

	static isPriorPeriodEvidence(document) {
		if (typeof document === 'number') {
			return document === documentTypes.PRIORYEAREVIDENCE || document === documentTypes.PRIORYEAREVIDENCEDOCUMENT;
		} else if (typeof document === 'object' && typeof document.documentTypeId !== 'undefined') {
			return (
				document.documentTypeId === documentTypes.PRIORYEAREVIDENCE ||
				document.documentTypeId === documentTypes.PRIORYEAREVIDENCEDOCUMENT
			);
		}
	}

	static getUniqueParentName(params) {
		let parentName;

		Object.values(params).forEach((param) => {
			if (!parentName) {
				parentName = '';
			}
			if (!_.isEmpty(param)) {
				if (parentName !== '') {
					parentName += '_';
				}

				parentName += param;
			}
		});

		return parentName;
	}

	static getDocumentExtension(
		documentTypeId,
		fileExt,
		hasComments,
		hasHiddenSheets,
		hasHighlights,
		isConflicted,
		trackChange,
		isReturned,
		isReadOnly,
		isConfidential
	) {
		// ToDo: Need to discuss and change accordingly
		let fileIcon;
		let fileStatus = '-blank-small';
		if (fileExt === undefined) {
			fileExt = '';
		}
		if (fileExtensionMapping) {
			let mappedName = _.find(fileExtensionMapping.mapping, function(items) {
				return items.keys.indexOf(fileExt.toUpperCase()) >= 0;
			});

			if (mappedName) {
				fileIcon = mappedName.mapIconName;
			} else {
				fileIcon = 'unknown';
			}
		}

		// Set File status icon (as per priority)
		if (isConflicted) {
			fileStatus = '-conflicts-small';
		} else if (trackChange) {
			fileStatus = '-tracked-changes-small';
		} else if (hasComments) {
			fileStatus = '-comments-small';
		} else if (hasHiddenSheets) {
			fileStatus = '-hidden-sheets-small';
		} else if (isReturned) {
			fileStatus = '-returned-small';
		} else if (isReadOnly) {
			fileStatus = '-locked-small';
		} else if (isConfidential) {
			fileStatus = '-locked-small';
		} else {
			/* empty */
		}

		return fileIcon + fileStatus;
	}

	/// get parent name to show progress bar only selected tab's document
	static getParentNameForSelectedTab = (parentName) => {
		// return if parentName is undefined
		if (!parentName) return;
		let getParentName = parentName.split('_');
		if (getParentName && getParentName.length > 0 && getParentName[1] !== undefined) {
			return getParentName[1];
		}

		return parentName;
	};

	static createQueryString(obj) {
		var params, i;

		params = [];
		for (i in obj) {
			if (obj.hasOwnProperty(i)) {
				params.push(i + '=' + encodeURIComponent(obj[i]));
			}
		}

		return params.join('&');
	}

	static isPaperProfile = (docType) => {
		return PaperProfileIDs.includes(docType, 0);
	};

	static isDocumentEligibleToOpenInV1 = (documentTypeId) => {
		return OpenInCanvasDocumentTypeIDs.includes(documentTypeId, 0);
	};

	static isClassicSummaryScreenDocumentType = (documentTypeId) => {
		return ClassicSummaryScreenDocumentTypes.includes(documentTypeId, 0);
	};

	static isDocumentTypeFitV2 = (documentTypeId) => {
		return GuidedWorkflowV2DocumentTypes.includes(documentTypeId, 0);
	};

	static isDocumentTypeFit = (documentTypeId) => {
		const fitDocumentTypes = [...GuidedWorkflowV2DocumentTypes, documentTypes.GUIDEDWORKFLOW];

		return fitDocumentTypes.includes(documentTypeId, 0);
	};

	static isDocumentIndependenceOrProfileForm = (documentTypeId) => {
		const independenceOrProfileDocumentTypes = [
			documentTypes.PROFILEV2,
			documentTypes.INDEPENDENCEFORMINDIVIDUAL,
			documentTypes.INDEPENDENCEFORMTEMPLATE
		];

		let isIndependenceOrProfile;
		if (!isNullOrUndefined(documentTypeId)) {
			isIndependenceOrProfile = independenceOrProfileDocumentTypes.includes(documentTypeId, 0);
		}

		return isIndependenceOrProfile;
	};

	static GetDocHelperStateKey(documentList, keyToSearch) {
		let keys = [];
		//Get all keys which mach with given key passed so that we can update the state
		_.map(documentList, function(value, key) {
			if (key.indexOf(keyToSearch) === 0) {
				keys.push(key);
			}
		});

		return keys;
	}

	/**
	 * Returns a boolean that determines if a change reason is required after uploading / editing a document.
	 * @param {object} engagement - Engagement object from the store.
	 * @param {object} quickLink - QuickLink object from the store.
	 * @param {object} document - Document data.
	 * @returns {bool} - Returns a boolean that determines if a change reason is required after uploading / editing a document
	 * */
	static isChangeReasonRequired(engagement, quickLink, document) {
		let changeReasonRequired = false;

		if (engagement?.engagementStatusId !== EngagementStatus.Restored) {
			let currentDate = moment().utc(),
				engagementReportDate;

			// A change reason is required is the current date is after the report release date and the engagement has a 440GL document
			// and the document does not have a conflict.
			if (engagement && engagement.expectedReportReleaseDate) {
				engagementReportDate = moment.utc(engagement.expectedReportReleaseDate);
				const isConflicted = document && document.isConflicted;

				changeReasonRequired =
					!isConflicted && quickLink && quickLink.hasModificationsAfterRRD && currentDate.isAfter(engagementReportDate);
			}
		}

		return changeReasonRequired;
	}

	static getTaskDocumentsApiUrl(inputData) {
		let url =
			env.getBaseURL(serviceURL, inputData.engagementId) +
			'Tasks/' +
			inputData.taskId +
			'/Documents?ReturnOnlyRelatedDocuments=true';

		if (inputData.workspaceId === undefined) {
			inputData.workspaceId = 0;
		}
		if (inputData.taskTypeId === undefined) {
			inputData.taskTypeId = 0;
		}

		if (inputData.queryStringInsert) {
			url =
				url +
				'&' +
				'workspaceid=' +
				inputData.workspaceId +
				'&' +
				'taskTypeId=' +
				inputData.taskTypeId +
				(inputData.returnTaskStatusAndFlagsOnly === true
					? '&' + 'returnTaskStatusAndFlagsOnly=' + inputData.returnTaskStatusAndFlagsOnly
					: '') +
				(inputData.isV2Return === true ? '&' + 'isV2Return=' + inputData.isV2Return : '');
		}
		return url;
	}

	static getAnnotationUrlByCategory(categoryId, annotationId, entityId) {
		let result;
		if (entityId) {
			result = (categoryId === entities.Document ? '&documentId=' : '&taskId=') + entityId;
		} else {
			result = '&annotationId=' + annotationId;
		}
		return result;
	}

	static getAnnotationsUrl(
		annotationId,
		entityId,
		engagementId,
		categoryId,
		returnsOnlyCount,
		includeAnnotationList,
		includeAnnotationReplies,
		annotationStatusIds,
		assignedTo,
		authoredBy,
		search,
		orderBy,
		pageSize,
		showAuthorAndAssigned,
		engagementSource = 1
	) {
		let optionalParamsQuery = '';
		if (search) {
			optionalParamsQuery += '&searchString=' + encodeURIComponent(search);
		}
		if (orderBy) {
			optionalParamsQuery += '&sortOrder=' + orderBy;
		}
		if (pageSize) {
			optionalParamsQuery += '&pageSize=' + pageSize;
		}
		if (assignedTo && !_.isEmpty(assignedTo)) {
			optionalParamsQuery += assignedTo.map((item) => `&reviewNotesAssignedTo=${item}`).join('');
		}
		if (authoredBy && !_.isEmpty(authoredBy)) {
			optionalParamsQuery += authoredBy.map((item) => `&reviewNotesAuthoredBy=${item}`).join('');
		}
		if (annotationStatusIds && !_.isEmpty(annotationStatusIds)) {
			optionalParamsQuery += annotationStatusIds.map((item) => `&annotationStatusIds=${item}`).join('');
		}
		if (showAuthorAndAssigned) {
			optionalParamsQuery += '&showAuthorAndAssigned=' + showAuthorAndAssigned;
		}
		return (
			env.getBaseURL(serviceURL, engagementId) +
			'Annotations?categoryId=' +
			categoryId +
			this.getAnnotationUrlByCategory(categoryId, annotationId, entityId) +
			'&returnsOnlyCount=' +
			returnsOnlyCount +
			'&includeAnnotationList=' +
			includeAnnotationList +
			'&includeAnnotationReplies=' +
			includeAnnotationReplies +
			'&engagementSource=' +
			engagementSource +
			optionalParamsQuery
		);
	}

	static getLocale(userPreferences) {
		let result = '';
		if (userPreferences) {
			result = userPreferences.displayLanguage;
			switch (userPreferences.languageId) {
				case 8:
					result = 'ja';
					break;
				case 9:
					result = 'zh-cn';
					break;
				case 10:
					result = 'zh-hk';
					break;
				default:
					break;
			}
		}
		return result;
	}

	static getTotalAccountCount = (accounts) => {
		return (
			Utility.getAccountTypeCount(accounts, AccountType.Significant) +
			Utility.getAccountTypeCount(accounts, AccountType.LimitedRisk) +
			Utility.getAccountTypeCount(accounts, AccountType.InSignificant)
		);
	};

	static getAccountTypeCount = (accounts, accountTypeId) => {
		if (accounts) {
			return accounts.filter((item) => item.accountTypeId === accountTypeId).length;
		}

		return 0;
	};

	static getAccountSeries = (option, significantCount, limitedCount, insignificantCount) => {
		let series = [];
		option = option.toString();
		let {AccountSummaryAccountType} = currentResource;
		AccountSummaryAccountType.slice(0)
			.reverse()
			.map((account) => {
				switch (account.id) {
					case '1':
						if (significantCount > 0) {
							series.push({
								name: labels.significantAccountsBarChart + ' (' + significantCount + ')',
								data: [significantCount],
								color: option === '0' || option === '1' ? 'rgba(21, 92, 180, 1)' : 'rgba(21, 92, 180, .3)',
								inactive: true
							});
						}
						break;
					case '2':
						if (limitedCount > 0) {
							series.push({
								name: labels.limitedAccounts + ' (' + limitedCount + ')',
								data: [limitedCount],
								color: option === '0' || option === '2' ? 'rgba(24, 140, 229, 1)' : 'rgba(24, 140, 229, .3)'
							});
						}
						break;
					case '3':
						if (insignificantCount > 0) {
							series.push({
								name: labels.insignificantAccounts + ' (' + insignificantCount + ')',
								data: [insignificantCount],
								color: option === '0' || option === '3' ? 'rgba(135, 211, 242, 1)' : 'rgba(135, 211, 242, .3)'
							});
						}
						break;
				}
			});

		return series;
	};

	static getValueInUserPrefferedNumberFormat = (value, numberFormat, isNumberFormattingRequired = true) => {
		if (value !== null) {
			if (value < 1 && value > 0) {
				// if this is between these 2 then treat it as '1'
				value = 1;
			}

			value = Math.round(value); // round it to integer

			let newValue = isNumberFormattingRequired
				? numberFormattedText(numberFormat, value === null || value === undefined ? '' : value.toString())
				: value;

			return newValue;
		}

		return '';
	};

	/**
	 * Return the current date format based in user preferences.
	 * @param {object} userPreferences - userPreferences from store
	 * @returns {string} current date format.
	 * */
	static getUserPreferencesDateLabel(userPreferences) {
		let dateFormat = dateFormats[defaultDateFormat] && dateFormats[defaultDateFormat].label;
		if (userPreferences.isPreferencesLoaded) {
			dateFormat = dateFormats[userPreferences.dateFormat] && dateFormats[userPreferences.dateFormat].label;
		}
		return dateFormat;
	}

	/**
	 * Return the current date format based in user preferences.
	 * @param {object} userPreferences - userPreferences from store
	 * @param {bool} isLocale - isLocale. Defaults to false.
	 * @returns {string} current date format.
	 * */
	static getUserPreferencesDateValue(userPreferences, isLocale = false) {
		let dateFormat = isLocale
			? dateFormats[defaultDateFormat] && dateFormats[defaultDateFormat].value
			: dateFormats[defaultDateFormat] && dateFormats[defaultDateFormat].momentLocale;
		if (userPreferences?.isPreferencesLoaded) {
			dateFormat =
				dateFormats[userPreferences?.dateFormat] &&
				(isLocale
					? dateFormats[userPreferences?.dateFormat].value
					: dateFormats[userPreferences?.dateFormat].momentLocale);
		}
		return dateFormat;
	}

	static getFormattedDateValue(userPreferences, date) {
		if (userPreferences && date) {
			let userDateFormat = Utility.getUserPreferencesDateValue(userPreferences);
			const formatedDate = moment(date);
			return Utility.getFormattedDate(formatedDate, userDateFormat);
		}

		return '';
	}

	static getEngagementUsersUrl(engagementId, userStatus) {
		let optionalParams = '';

		if (userStatus && !_.isEmpty(userStatus)) {
			optionalParams += userStatus.map((item) => `&userStatus=${item}`).join('');
		}

		let returnValue = env.getBaseURL(serviceURL, engagementId) + 'Users';

		if (optionalParams) {
			returnValue += '?' + optionalParams.substring(1); //removing first & to make adding params easier
		}

		return returnValue;
	}

	static getDocumentHelperKey = (documentId, documentName, fileExt) => {
		let result = `${documentName}${fileExt ? `.${fileExt}` : ''}`;
		if (documentId) {
			result += `_${documentId}`;
		}

		return result;
	};

	static normalize = (field, accumulator, key, replacePush) => {
		let result = accumulator;

		// If an accumulator is passed, the result should be at least, that
		if (!result) {
			result = {
				byId: {},
				allIds: []
			};
		}

		// Run array normalization logic
		if (field) {
			if (Array.isArray(field)) {
				for (let k = 0; k < field.length; k++) {
					const entity = field[k];

					const index = key ? entity[key] : entity.id;
					const resultEntity = result.byId[index];

					if (!replacePush || !resultEntity) {
						result.allIds.push(index);
					}
					result.byId[index] = {...resultEntity, ...entity};
				}
			} else {
				const index = key ? field[key] : field.id;
				if (!replacePush || !result.byId[index]) {
					result.allIds.push(index);
				}
				result.byId[index] = {...result.byId[index], ...field};
			}
		}

		return result;
	};

	static safeNormalize = (field, accumulator, key = 'id', replacePush) => {
		let newObject;
		if (accumulator) {
			newObject = {
				...accumulator,
				byId: {...accumulator.byId},
				allIds: [...accumulator.allIds]
			};
		}

		return this.normalize(field, newObject, key, replacePush);
	};

	static getUrlForFormData = (engagementId, documentId, queryParams) => {
		return env.getBaseURL(serviceURL, engagementId) + 'Forms/' + documentId + '?' + queryParams;
	};

	static validateDocumentName(documentName, isPriorPeriod) {
		let error = false;
		let errorMessage = '';

		const regexEmpty = /^\s*$/;
		const regexCharacter = /^[^"<*/:\\?|>]+$/i;

		if (regexEmpty.test(documentName)) {
			if (errorMessage !== '') {
				errorMessage += ' ';
			}

			errorMessage += isPriorPeriod ? labels.docNameRequired : labels.fileNameRequired;
		} else if (!documentName.match(regexCharacter)) {
			if (errorMessage !== '') {
				errorMessage += ' ';
			}

			errorMessage += isPriorPeriod ? labels.docInvalidCharacters : labels.invalidCharacters;
		}

		if (documentName.length > documentNameMaxLength) {
			if (errorMessage !== '') {
				errorMessage += ' ';
			}

			errorMessage += labels.maxLengthExceeded;
		}

		if (errorMessage !== '') {
			error = true;
		} else {
			errorMessage = undefined;
		}

		return [error, errorMessage];
	}

	static validateInputText(inputText, errorLabel) {
		let error = false;
		let errorMessage = '';

		const regexCharacter = /^[^"<*/:\\?|>]+$/i;

		if (!inputText.match(regexCharacter)) {
			errorMessage = errorLabel;
		}

		if (errorMessage !== '') {
			error = true;
		} else {
			errorMessage = undefined;
		}

		return [error, errorMessage];
	}

	// Returns whether Body Is Disabled
	static IsBodyDisabled = (permissions, actions) => {
		let isBodyDisabled = false;

		if (!permissions.canUpdateEngagementContent) {
			isBodyDisabled = false;
		} else if (permissions.canUpdateEngagementContent) {
			const actionFound = actions.some((action) => {
				return action.actionTypeId === actionType.IndependenceException;
			});

			isBodyDisabled = actionFound;
		}

		return isBodyDisabled;
	};

	static getFormattedDate = (date, dateFormat) => {
		if (date instanceof moment) {
			return date.format(dateFormat);
		}
		return date;
	};

	static getLocalizedFormattedDateTime = (date) => {
		return date.replace('AM', labels.amLabel).replace('PM', labels.pmLabel);
	};

	/*********************************
					TASK
	***********************************/

	static getTaskUrl = (
		taskId,
		taskTypeId,
		engagementInformation,
		versionNumber = null,
		isV1Redirect = null,
		categoryId = OfflineTaskListFilters.categoryId,
		subCategoryId = OfflineTaskListFilters.subcategoryId,
		documentId
	) => {
		let url = '';
		let redirectToCanvas = false;
		if (versionNumber) {
			redirectToCanvas = versionNumber === 1;
		} else {
			redirectToCanvas = isV1Redirect || false;
		}
		if (redirectToCanvas) {
			url = this.getCanvasTaskDetailsWebUrl(canvasUrlParams.taskDetails, engagementInformation, taskId, taskTypeId);
		} else {
			url = `${env.getURL('hercules_web')}/dashboard?category=all
		&deeplinkdocumentid=${documentId}&engagementid=${engagementInformation.engagementId}&searchtype=contains
		&deeplinktaskid=${taskId}&viewdocumenttab=evidences&viewtype=tasks#engagementOverview`;
			/*url = env.getWebUrl(
				`${taskApiRoutes.task}${categoryId}/${subCategoryId}/${taskId.toLowerCase()}?engagementid=${
					engagementInformation.engagementId
				}`
			);*/
		}
		return url;
	};

	/**
	 * forms canvas inCountry url.
	 * @param {string} route - the route to add to canvas url
	 * @param {string} engagementInformation - engagement information
	 * @param {string} taskId - current route values. State values
	 * @param {number} taskTypeId - task type id
	 * @returns {string} canvas inCountry url for the route
	 * */
	static getCanvasTaskDetailsWebUrl(route, engagementInformation, taskId, taskTypeId) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;

		return [
			inCountryBaseUrl,
			'/pages/index/index.html',
			'?',
			canvasUrlParams.countryid,
			'=',
			engagementInformation.countryId,
			'&',
			canvasUrlParams.engagementid,
			'=',
			engagementId,
			'&',
			canvasUrlParams.engagementdesc,
			'=',
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)),
			'&',
			canvasUrlParams.workspacedesc,
			'=',
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)),
			'&',
			canvasUrlParams.workspaceid,
			'=',
			engagementInformation.workspaceId,
			'&',
			canvasUrlParams.engagementversion,
			'=',
			engagementInformation.engagementVersion,
			'&',
			canvasWebRoutes[route],
			'/',
			taskId,
			'/',
			taskTypeId
		].join('');
	}

	static getTaskTypeDetails(taskTypeId, isEp, isEq, isEpEqr) {
		let taskType = -1;
		let isUserCreated = false;

		if (_.inRange(Number(taskTypeId), 1, 7)) {
			/*Control task*/
			taskType = 4;
			isUserCreated = true;
		} else if (_.inRange(taskTypeId, 7, 12)) {
			/*Response Task*/
			taskType = 7;
			isUserCreated = false;
		} else if (_.inRange(taskTypeId, 12, 14)) {
			/*Other Standard Task*/
			taskType = 1;
			isUserCreated = true;
		} else if (taskTypeId === 14) {
			/*Primary Standard Task*/
			taskType = 2;
			isUserCreated = false;
		} else if (taskTypeId === 22) {
			/*Account Conclusion Task*/
			taskType = 22;
			isUserCreated = false;
		} else if (taskTypeId === 15 || taskTypeId === 16 || taskTypeId === 26) {
			/*Substantive Task*/
			taskType = 5;
			isUserCreated = true;
		} else if (taskTypeId === 17) {
			/*Substantive Task*/
			taskType = 6;
			isUserCreated = true;
		} else if (_.inRange(taskTypeId, 18, 21)) {
			/*Walkthrough Task*/
			taskType = taskTypeId === 19 ? 23 : 3;
			isUserCreated = true;
		} else if (_.inRange(taskTypeId, 23, 26)) {
			/*Group Task*/
			taskType = 8;
			isUserCreated = false;
		} else if (taskTypeId === 27) {
			/*Group Task*/
			taskType = 8;
			isUserCreated = true;
		} else {
			/*show blank*/
			taskType = 0;
		}

		if (isEp && isEp === true) {
			taskType = 9;
			isUserCreated = false;
		}
		if (isEq && isEq === true) {
			taskType = 10;
			isUserCreated = false;
		}
		if ((isEpEqr && isEpEqr === true) || (isEp && isEp === true && isEq && isEq === true)) {
			taskType = 11;
			isUserCreated = false;
		}

		return {
			taskType: taskType,
			isUserCreated: isUserCreated,
			description: taskType >= 0 ? currentResource.taskTypeBadge[taskType] : ''
		};
	}

	// This is used to hide/show buttons in modal
	static displayButtons = (isOverwriteModal) => {
		return isOverwriteModal ? true : false;
	};

	// Return title to the modal
	static getModalTitle = (comingFrom, isOverwriteModal, categoryName) => {
		if (isOverwriteModal) return labels.overwriteForm;

		switch (comingFrom) {
			case relateDocumentsTo.canvasForm:
				return labels.relateDocumentsTitle;
			case relateDocumentsTo.canvasFormBody:
				return labels.relateDocumentsToBodyTitle;
			case relateDocumentsTo.canvasFormBodyAres:
				switch (categoryName) {
					case documentCategoryNames.priorPeriod:
						return labels.priorPeriodRelateDocument;
					case documentCategoryNames.temporary:
						return labels.relateTemporaryFiles;
					case documentCategoryNames.external:
						return labels.relateExternalDocuments;
					default:
						return labels.relateDocumentsToBodyAresTitle;
				}
			default:
				return labels.relateDocumentsTitle;
		}
	};

	// Return snapshot operation
	static getSnapshotCompareLabel = (snapshotModel, isTrackChanges) => {
		if (snapshotModel?.isAdded) {
			return isTrackChanges ? labels.added : labels.snapshotNew;
		}
		if (snapshotModel?.isChanged) {
			return labels.snapshotUpdate;
		}
		if (snapshotModel?.isDeleted && !isTrackChanges) {
			return labels.snapshotRemoved;
		}
		return undefined;
	};

	static formatSnapshotsName = (snapshots) => {
		let snapShotsFromServer = [];
		if (snapshots && snapshots.length > 0) {
			snapShotsFromServer = snapshots.map((item) => {
				let snapshotName;

				switch (item.documentSourceID) {
					case documentSources.RESTORE:
						snapshotName = labels.snapshotRestore;
						break;
					case documentSources.ROLLFORWARD:
						snapshotName = labels.snapshotRollforward;
						break;
					case documentSources.COPYENGAGEMENT:
					case documentSources.COPYCANVASFORM:
						snapshotName = labels.snapshotCopy;
						break;
					default:
						snapshotName = item.userName;
				}

				return {
					value: item.id,
					label: item.userName,
					title: item.userName,
					userName: snapshotName,
					createDate: item.createDate
				};
			}, this);
		}
		return snapShotsFromServer;
	};

	static getInstructionalText = (comingFrom, isOverwriteModal, categoryName) => {
		if (isOverwriteModal) return labels.overwriteFormDesc;

		switch (comingFrom) {
			case relateDocumentsTo.canvasForm:
				return labels.relateDocumentsDesc;
			case relateDocumentsTo.canvasFormBody:
			case relateDocumentsTo.canvasFormBodyAres:
				return categoryName === documentCategoryNames.priorPeriod ||
					categoryName === documentCategoryNames.external ||
					categoryName === documentCategoryNames.temporary
					? labels.relateDocumentsToTheBody
					: labels.relateDocumentsToBodyDesc;
			default:
				return labels.relateDocumentsDesc;
		}
	};

	// Return title for ADC modal
	static getAdcModalTitle = (entityId, isSharedForm) => {
		switch (entityId) {
			case entities.SCOT:
				return isSharedForm ? labels.viewScot : labels.editScot;
			case entities.WCGW:
				return isSharedForm ? labels.viewWcgw : labels.editWcgw;
			case entities.ItProcess:
				return isSharedForm ? labels.viewITSOProcess : labels.editITSOProcess;
			case entities.ItSoApplication:
				return isSharedForm ? labels.viewITAppSO : labels.editITAppSO;
			case entities.Control:
				return isSharedForm ? labels.viewControl : labels.editControl;
			case entities.ItControl:
				return isSharedForm ? labels.viewITControl : labels.editITControl;
			case entities.Risk:
				return isSharedForm ? labels.viewRisk : labels.editRisk;
		}
	};

	static getAdcStrategyTitle = (entityId) => {
		switch (entityId) {
			case entities.SCOT:
				return labels.scotStrategy;
			case entities.WCGW:
				return labels.wcgwStrategy;
			case entities.ItProcess:
				return labels.itProcessStrategy;
		}
	};

	// Return description for ADC modal
	static getAdcModalDescriptionTitle = () => {
		return Utility.createRichTextElement(labels.editCanvasformObjects, '');
	};

	// Return description for View modal
	static getViewModalDescription = (entityName, className) => {
		const name = <span className={`${className ? className : ''}`}>{entityName}</span>;
		return (
			<span>
				{Utility.createRichTextElement(labels.scotRelatedControls)}
				{name}
			</span>
		);
	};

	// get class to DisableADCLink
	static getClasstoDisableADCLink(userPreferences, isSnapshotView) {
		if ((userPreferences && userPreferences.isGuestUser && !userPreferences.isCEAPUser) || isSnapshotView) {
			return 'disableLinksExternalUsers';
		}
		return '';
	}

	/**
	 * Return text, text wrapped in a span or rich text.
	 * @param {string} text - text to return
	 * @param {boolean} isSnapshotView - if snapshot just return text.
	 * @param {boolean} isRichText - most inputs do not allow for rich text, pass false if not needing to render rich text.
	 * @returns {object} - returns a span with text in it.
	 */
	static getHtmlTextElement(text, isSnapshotView, isRichText = true) {
		if (!isSnapshotView) {
			return text;
		}
		if (!isRichText) {
			return <span className="RichTextBodySpan">{text}</span>;
		}
		return <span className="RichTextBodySpan" dangerouslySetInnerHTML={Utility.createMarkup(text)} />;
	}

	static getHtmlTextWithTitleTip(text, className) {
		return <span title={text} className={className} dangerouslySetInnerHTML={Utility.createMarkup(text)} />;
	}

	static getStoredPayload = (bodyId) => {
		return storedPayload[bodyId];
	};

	static setStoredPayload = (bodyId, payload) => {
		storedPayload[bodyId] = payload;
	};

	static removedStoredPayload = (bodyId) => {
		delete storedPayload[bodyId];
	};

	static getDragAndDropUploadObject = () => {
		return dragAndDropUploadObject;
	};

	static setDragAndDropUploadObject = (object) => {
		dragAndDropUploadObject.push(object);
	};

	static removeDragAndDropUploadObject = () => {
		dragAndDropUploadObject = [];
	};

	static hasDragAndDropUploadObject = () => {
		return dragAndDropUploadObject.length > 0;
	};

	static getSignoffsRequirements = (bodyTypeId) => {
		switch (bodyTypeId) {
			case formBodyType.DocumentUploadEQRApprovalRequired:
				return {
					isEQRSignoffUserRequired: true
				};
			case formBodyType.DocumentUploadPICApprovalRequired:
				return {
					isEPSignoffUserRequired: true
				};
			case formBodyType.DocumentUploadPICEQRApprovalRequired:
				return {
					isEQRSignoffUserRequired: true,
					isEPSignoffUserRequired: true
				};
			case formBodyType.DocumentUploadAnyApprovalRequired:
				return {
					isEQRSignoffUserRequired: false,
					isEPSignoffUserRequired: false
				};
			default:
				return {};
		}
	};

	static getAresTaskListNavigationUrl = (
		documentId,
		headerId,
		sectionId,
		engagementId,
		taskId,
		queryParameters,
		documentTypeId,
		isTrackChanges,
		isCompareResponses,
		isAttributesView,
		stEntityId
	) => {
		const excludeKeys = [];
		if (engagementId) {
			excludeKeys.push('engagementid');
		}

		if (taskId) {
			excludeKeys.push('taskid');
		}

		if (documentId) {
			excludeKeys.push('documentid');
		}

		const _headerId = headerId === -1 ? 'summary' : headerId;

		// As we have Track changes, Compare responses, Attributes view only on v2.
		let url =
			this.isDocumentTypeFitV2(documentTypeId) || isTrackChanges || isCompareResponses || isAttributesView
				? `/${aresTaskViewRoutes.guidedworkflowV2}`
				: `/${aresTaskViewRoutes.guidedworkflow}`;

		if (isTrackChanges) {
			url += `/changes`;
		} else if (isCompareResponses) {
			url += `/compare`;
		} else if (isAttributesView) {
			url += `/attributes`;
		}

		if (documentId) {
			// Activity page url:
			url += `/${documentId}`;

			if (_headerId && _headerId !== 'summary') {
				url += `/${aresTaskViewRoutes.header}/${_headerId}`;

				if (sectionId) {
					url += `/${aresTaskViewRoutes.section}/${sectionId}`;
				}
			} else if (_headerId === 'summary') {
				url += `/${aresTaskViewRoutes.summary}`;
			}
		}

		url += `?${canvasUrlParams.engagementid}=${engagementId}`;

		if (taskId) {
			url += `&taskId=${taskId}`;
		}

		if (stEntityId) {
			delete queryParameters.stEntityId;
			delete queryParameters.stentityid;
			url += `&stentityid=${stEntityId}`;
		}
		const query = getFilteredQueryParameter(queryParameters, excludeKeys);
		if (query) {
			url += this.appendObjectParams(query);
		}

		return url;
	};

	static getEvidenceDocumentTypeFromTemporaryDocumentType = (documentType) => {
		let evidenceDocumentType = null;
		if (documentType == null) {
			return evidenceDocumentType;
		}

		switch (documentType) {
			case documentTypes.CANVASFORMTEMPORARY:
			case documentTypes.GUIDEDWORKFLOWTEMPORARY:
			case documentTypes.GUIDEDWORKFLOWV2_TEMPORARY:
			case documentTypes.ACCOUNT_STANDARD_WORKING_PAPER_TEMPORARY:
			case documentTypes.ALRA_INDIVIDUAL_TEMPORARY: {
				evidenceDocumentType = EvidenceDocumentTypeFromTemporaryDocumentTypeMap[documentType];
				break;
			}
			default:
				evidenceDocumentType = documentTypes.EVIDENCE;
				break;
		}

		return evidenceDocumentType;
	};

	static appendObjectParams = (params) => {
		let append = '';

		Object.entries(params).forEach((entry) => {
			const [name, value] = entry;
			append += `&${name.toLowerCase()}`;
			if (value !== null && value !== undefined) {
				append += `=${value}`;
			}
		});

		return append;
	};

	static getAccountParams = (queryParameters) => {
		let params = '';

		if (queryParameters) {
			Object.entries(queryParameters).forEach((entry, i) => {
				const [name, value] = entry;
				params += i === 0 ? `${name}` : `&${name}`;
				if (value !== null && value !== undefined) {
					params += `=${value}`;
				}
			});
		}

		return params;
	};

	static convertUserPreferencesDateFormatToMoment(userFormat) {
		switch (userFormat) {
			case dateFormats[0].id:
				return 'MM/DD/YYYY';
			case dateFormats[1].id:
				return 'DD/MM/YYYY';
			case dateFormats[2].id:
				return 'YYYY/MM/DD';
		}
	}

	static formatGetAllDocumentsApprovalsForSignOffsControl(approvals, userPreferences) {
		return approvals.map((approval) => {
			return {
				...approval,
				approvalId: approval.id,
				isFromLoggedInUser: userPreferences.id === approval.approvalUserId
			};
		});
	}

	static getTheme() {
		return document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'light' ? null : 'dark';
	}

	static isDarkTheme = () => document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'dark';

	static getRouteValueAt = (idx) => {
		const routeTokens = location.pathname.replace(/^\/+/g, '').split('/');
		return routeTokens.length > idx ? routeTokens[idx] : undefined;
	};

	static showISA315Counter = (counter) => {
		return counter > 0 ? counter : '-';
	};

	static getInitials = (names) => {
		let _names = names || '';
		let initials = '';

		if (_names.length === 1) {
			initials = names[0];
		} else {
			initials = _names
				.split(' ')
				.map((item) => item.charAt(0))
				.join('');
		}

		return initials.substring(0, 3).toUpperCase();
	};

	static isValueModified(originalValue, modifiedValue) {
		if (
			modifiedValue !== undefined &&
			modifiedValue !== null &&
			modifiedValue !== '' &&
			modifiedValue !== originalValue
		) {
			return true;
		}

		return false;
	}

	static hasValue(value) {
		let result = false;

		switch (typeof value) {
			case 'object':
				if (Array.isArray(value)) {
					if (value.length > 0) {
						result = true;
					}
				} else {
					result = !_.isEmpty(value);
				}
				break;
			case 'string':
				if (value !== undefined && value !== null && value.trim() !== '') {
					result = true;
				}
				break;
			default:
				if (value !== undefined && value !== null) {
					result = true;
				}
				break;
		}

		return result;
	}

	static calculateValidationCounters(headers, validations, filter, documentTypeId) {
		let incompleteCount = 0,
			unresolvedCommentCount = 0;

		headers &&
			headers.length > 0 &&
			validations &&
			validations.length > 0 &&
			headers.forEach((header) => {
				const headerCounts = getValidationCountForIds(
					header,
					undefined,
					undefined,
					validations,
					filter,
					documentTypeId
				);

				if (filter === validationFilter.INCOMPLETE || filter === validationFilter.NONE) {
					incompleteCount += headerCounts.incompleteCount;
				}

				if (filter === validationFilter.COMMENTS || filter === validationFilter.NONE) {
					unresolvedCommentCount += headerCounts.unresolvedCount;
				}
			});

		return {incompleteCount, unresolvedCommentCount};
	}

	static calculateValidationForSingleHeader(headerId, validations, filter, documentTypeId) {
		let incompleteCount = 0,
			unresolvedCommentCount = 0;

		if (validations && validations.length > 0) {
			const headerCounts = getValidationCountForIds(
				headerId,
				undefined,
				undefined,
				validations,
				filter,
				documentTypeId
			);

			if (filter === validationFilter.INCOMPLETE || filter === validationFilter.NONE) {
				incompleteCount += headerCounts.incompleteCount;
			}

			if (filter === validationFilter.COMMENTS || filter === validationFilter.NONE) {
				unresolvedCommentCount += headerCounts.unresolvedCount;
			}
		}
		return {incompleteCount, unresolvedCommentCount};
	}

	static calculateValidationForSingleSection(headerId, sectionId, validations, filter, documentTypeId) {
		let incompleteCount = 0,
			unresolvedCommentCount = 0;

		if (validations && validations.length > 0) {
			const sectionCounts = getValidationCountForIds(
				headerId,
				sectionId,
				undefined,
				validations,
				filter,
				documentTypeId
			);

			if (filter === validationFilter.INCOMPLETE || filter === validationFilter.NONE) {
				incompleteCount += sectionCounts.incompleteCount;
			}

			if (filter === validationFilter.COMMENTS || filter === validationFilter.NONE) {
				unresolvedCommentCount += sectionCounts.unresolvedCount;
			}
		}
		return {incompleteCount, unresolvedCommentCount};
	}

	static getDateFormatWithoutYear = (dateFormat) => {
		let result = dateFormat;
		const regExp = '(^/)*([/yY]{5})|($/)w+';
		let capture = result.match(regExp);
		if (capture !== null && capture.length > 0) {
			result = result.replace(capture[0], '');
		}
		return result;
	};

	static addDays = (date, days) => {
		let returnDate = new Date(date);
		returnDate.setDate(returnDate.getDate() + days);
		return returnDate;
	};

	static applyRounding = (value, decimals = 0) => {
		return parseFloat(applyRound(value, decimals));
	};

	static mapOrder = (array, order, key) => {
		array.sort(function(a, b) {
			var A = a[key],
				B = b[key];

			if (order.indexOf(A) > order.indexOf(B)) {
				return 1;
			} else {
				return -1;
			}
		});

		return array;
	};

	static isSmartAutomationEvidence = (documentTypeId) => {
		return SmartAutomationEvidenceIDs.includes(documentTypeId, 0);
	};

	static isVoiceNoteRecordingEnabled = (state) => {
		// This value is from server configuration. It would applies for all engagements on that server.
		const serverIsVoiceNoteRecordingEnabled = !!state.configurations?.features?.isVoiceNoteRecordingEnabled;

		// This value only applies when one of the following occurs:
		// - US GAAS + Listed
		// - Canadian GAAS + Listed
		// - Canadian GAAS + Other public interest entity that is not listed
		const engagementIsVoiceNoteRecordingEnabled = !!state.engagement?.isVoiceNoteRecordingEnabled;

		return serverIsVoiceNoteRecordingEnabled && engagementIsVoiceNoteRecordingEnabled;
	};

	static getOARHelixLink = (helixData, oarData, type) => {
		let url = '';
		if (helixData && helixData?.length > 0) {
			let primaryAnalyzer = helixData[1];
			if (primaryAnalyzer) {
				url = env.getBaseURL('Helix_Platform_Base_Url') + 'app/projects/view-analytics/';
				url += `${primaryAnalyzer?.projectId}/${primaryAnalyzer?.helixAnalyzerId}`;
				let businessUnit = '';
				if (oarData?.businessUnit && oarData?.businessUnit.length > 0) {
					businessUnit += '~&~BU=';
					oarData?.businessUnit.forEach((bu) => {
						businessUnit += bu + '~|~';
					});
				}
				if (businessUnit.length > 0 && businessUnit.charAt(businessUnit.length - 1) === '~') {
					businessUnit = businessUnit.substring(0, businessUnit.length - 3);
				}
				let queryString = '';
				if (oarData?.secondComparativePeriod) {
					queryString = `Report_Key=FSC~&~Component_key=Balcomp3p~&~AnalysYtd=${
						oarData?.analysisPeriod?.yearToDateQuery
					}~&~CompYtd=${oarData?.comparativePeriod?.yearToDateQuery}~&~2CompYtd=${
						oarData?.secondComparativePeriod?.yearToDateQuery
					}~&~CurCd=${oarData?.currencyCode}~&~CurType=${oarData?.currencyType}${businessUnit}~&~AcTyp=${
						type === 'income' ? 'Revenue~|~Expenses' : 'Assets~|~Liabilities~|~Equity'
					}`;
				} else {
					queryString = `Report_Key=FSC~&~Component_key=BalCompT~&~AnalysYtd=${
						oarData?.analysisPeriod?.yearToDateQuery
					}~&~CompYtd=${oarData?.comparativePeriod?.yearToDateQuery}~&~CurCd=${oarData?.currencyCode}~&~CurType=${
						oarData?.currencyType
					}${businessUnit}~&~AcTyp=${type === 'income' ? 'Revenue~|~Expenses' : 'Assets~|~Liabilities~|~Equity'}`;
				}
				url += '?state=' + encodeURIComponent(btoa(encodeURIComponent(queryString)));
			}
		}
		return url;
	};

	static getMeasurementBasisUrl = (primaryProject) => {
		let url = '';
		if (primaryProject?.projectId) {
			url = env.getBaseURL('Helix_Platform_Base_Url') + 'app/projects/view-analytics/';
			url += `${primaryProject.projectId}/${primaryProject.helixAnalyzerId}`;
		}
		return url;
	};

	/**
	 * Determines if the current page is in an iframe element.
	 * @returns {boolean} true if the current page is in an iframe element, false otherwise.
	 */
	static pageInIframe() {
		return window.location !== window.parent.location;
	}

	static isDocumentCanvasForm = (documentTypeId) => {
		return CanvasFormsIds.includes(documentTypeId, 0);
	};

	static getKronosUrl() {
		const match = matchRoutes(
			[
				{path: '/canvasform'},
				{path: '/independence'},
				{path: '/profile'},
				{path: '/canvasform/changes'},
				{path: '/canvasform/details'}
			],
			window.location.pathname
		);
		if (Array.isArray(match) && match.length > 0 && match[0].params) {
			const url = match[0].pathname;
			return url;
		}
		return '';
	}

	static getRelativeDate(date) {
		const DIVISIONS = [
			{amount: 7, name: labels.daysAgo},
			{amount: 4.34524, name: labels.weeksAgo},
			{amount: 12, name: labels.monthsAgo},
			{amount: Number.POSITIVE_INFINITY, name: labels.yearsAgo}
		];

		let duration = Math.round((Date.now() - new Date(date).getTime()) / (1000 * 3600 * 24));

		for (let i = 0; i <= DIVISIONS.length; i++) {
			const division = DIVISIONS[i];

			if (duration < division.amount) {
				if (division.name === labels.daysAgo) {
					switch (duration) {
						case 0:
							return labels.today;
						case 1:
							return labels.yesterday;
						default:
							return `${duration} ${labels.daysAgo}`;
					}
				}

				if (division.name === labels.weeksAgo) {
					if (Math.trunc(duration) === 1) {
						return `1 ${labels.weekAgo}`;
					}

					return `${Math.trunc(duration)} ${labels.weeksAgo}`;
				}

				if (division.name === labels.monthsAgo) {
					if (Math.trunc(duration) === 1) {
						return `1 ${labels.monthAgo}`;
					}

					return `${Math.trunc(duration)} ${labels.monthsAgo}`;
				}

				if (division.name === labels.yearsAgo) {
					if (Math.trunc(duration) === 1) {
						return `1 ${labels.yearAgo}`;
					}

					return `${Math.trunc(duration)} ${labels.yearsAgo}`;
				}
			}

			duration /= division.amount;
		}
	}

	static trimText = (text, maxLenght) => {
		if (text.length > maxLenght) {
			return text.substring(0, maxLenght);
		}
		return text;
	};

	static getLastChildFromValidations = (validations) => {
		let deepestObject = null;
		let maxDepth = -1;

		function traverse(obj, depth = 0) {
			if (Array.isArray(obj)) {
				obj.forEach((item) => traverse(item, depth + 1));
			} else if (typeof obj === 'object' && obj !== null) {
				if (depth > maxDepth) {
					maxDepth = depth;
					deepestObject = obj;
				}
				Object.values(obj).forEach((value) => traverse(value, depth + 1));
			}
		}

		traverse(validations);

		return deepestObject;
	};

	static documentHasLeftNavigation = (documentTypeId) => {
		return CanvasFormsWithoutNavigationPanel.indexOf(documentTypeId) === -1;
	};

	static checkValidationsForEstimate = (estimateId, riskId, smartEntityId) => {
		return isNullOrUndefined(riskId) || (isNullOrUndefined(smartEntityId) && smartEntityId !== estimateId);
	};

	static isEstimateDataValidForDisplay = (riskTypeId) => {
		const riskTypesOfEstimates = riskTypeList.filter((riskType) => {
			return ![riskTypes.SIGNIFICANTRISK, riskTypes.FRAUDRISK, riskTypes.INHERENTRISK].includes(riskType.id);
		});
		return riskTypesOfEstimates.some((x) => x.id == riskTypeId);
	};

	static removeTags(str) {
		if (!str || str === null || str === '') return false;
		else str = str.toString();
		return str.replace(/(<([^>]+)>)/gi, '');
	}

	static findSectionById = (headers, sectionId) => {
		for (let header of headers) {
			for (let section of header.sections) {
				if (section.id === sectionId) {
					return section;
				}
			}
		}
		return null; // Return null if no matching section is found
	};

	static removeQueryStringProperties = (url, propertiesToRemove) => {
		// Parse the URL and query string
		const parsedUrl = new URL(url);
		const queryParams = queryString.parse(parsedUrl.search);

		// Remove the specified properties
		propertiesToRemove.forEach((property) => {
			delete queryParams[property];
		});

		// Stringify the updated query parameters
		parsedUrl.search = queryString.stringify(queryParams);
		return parsedUrl.toString();
	};

	static isValidNumber(number) {
		return typeof number === 'number' && number > 0 && Number.isInteger(number);
	}

	static isDocumentEligibleForDaaSCheckOut(document) {
		var documentStatus =
			document?.documentStatusId < DocumentStatus.DaaSCheckoutComplete ||
			document?.documentStatusId > DocumentStatus.DaaSDiscardError ||
			[
				DocumentStatus.DaaSCheckoutError,
				DocumentStatus.DaaSCheckinComplete,
				DocumentStatus.DaaSDiscardComplete
			].includes(document?.documentStatusId);

		return documentStatus;
	}

	static isDocumentEligibleForDaaSCheckIn(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			[DocumentStatus.DaaSCheckoutComplete, DocumentStatus.DaaSCheckinError, DocumentStatus.DaaSDiscardError].includes(
				document?.documentStatusId
			)
		);
	}

	static isDaaSDocumentCheckOutInProgress(document) {
		return document?.documentStatusId === DocumentStatus.DaaSCheckoutInProgress;
	}

	static isDaaSDocumentCheckOutComplete(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSCheckoutComplete
		);
	}

	static isDaaSDocumentCheckInInProgress(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSCheckinInProgress
		);
	}

	static isDaaSDocumentCheckInError(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSCheckinError
		);
	}

	static isDaaSDocumentCheckOutCheckInInProgress(document) {
		return this.isDaaSDocumentCheckOutInProgress(document) || this.isDaaSDocumentCheckInInProgress(document);
	}

	static getKnowledgeAssertionId = (statementTypeId) => {
		switch (statementTypeId) {
			case StatementType.Income:
				return AssertionIds[StatementType.Income].Measurement;
			case StatementType.BalanceSheet:
				return AssertionIds[StatementType.BalanceSheet].Valuation;
			default:
				return AssertionIds[StatementType.Both].MeasurementValuation;
		}
	};

	static getPrintUrl(baseDomain, engagementId, documentId, userPreferences) {
		const snapshotUser = `${userPreferences.firstName} ${userPreferences.lastName}`;
		let formPrintUrl =
			baseDomain +
			`print?engagementid=${engagementId}&documentid=${documentId}&snapshotid=${-1}&snapshotuser=${encodeURIComponent(
				snapshotUser
			)}&isAutomatedPrint=true`;

		return formPrintUrl;
	}
}

export default Utility;
